<template>
    <div class="config-list">
        <a-radio-group v-model="type">
            <div class="item">
                <div class="list">
                    <a-checkbox-group v-model="valueList">
                        <template v-for="i in specifyRange">
                            <a-checkbox class="list-check-item" :key="`key-${i}`" :value="i">{{i}}</a-checkbox>
                        </template>
                    </a-checkbox-group>
                </div>
            </div>
        </a-radio-group>
    </div>
</template>

<script>
    import mixin from './mixin'

    export default {
        name: 'minute',
        mixins: [mixin],
        data() {
            return {}
        },
        watch: {
            value_c(newVal, oldVal) {
                this.$emit('change', newVal)
            }
        },
        created() {
            this.DEFAULT_VALUE = '*'
            this.minValue = 0
            this.maxValue = 23
            this.valueRange.start = 0
            this.valueRange.end = 23
            this.valueLoop.start = 0
            this.valueLoop.interval = 1
            this.parseProp(this.prop)
        }
    }
</script>

<style lang="less" scoped>
    @import "mixin.less";
</style>